import React, { memo, useEffect, useState } from 'react'

import { Box, Link, Typography } from '@material-ui/core'

import useGuestJourney from 'hooks/useGuestJourney'
import useSnackbar from 'hooks/useSnackbar'

import helpers from 'helpers'
import * as service from 'service'

const ResendEmail = ({ email }) => {
  const [enableResendButton, setEnableResendButton] = useState(false)
  const [counter, setCounter] = useState(30)
  const [loading, setLoading] = useState(false)

  const snackbar = useSnackbar()
  const { guestModule, portalToken, setAccessToken } = useGuestJourney()

  const publicPath = window.location.origin + window.location.pathname

  const resendEmail = async () => {
    setLoading(true)
    try {
      const response = await service.guestPortal.company.validateEmail(
        portalToken,
        email,
        guestModule,
        publicPath,
      )
      setAccessToken(response?.data?.accessToken)
      setEnableResendButton(false)
      snackbar.open({
        message: 'O código foi reenviado. Verifique seu e-mail.',
        variant: 'success',
      })
    } catch (error) {
      snackbar.open({
        message:
          helpers.formatters.errorMessage(error?.response?.data?.error) ||
          'Erro ao reenviar o código. Tente novamente.',
        variant: 'error',
      })
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    if (!enableResendButton) setEnableResendButton(counter === 0)

    const timer =
      !enableResendButton &&
      setInterval(() => setCounter((prev) => prev - 1), 1000)

    return () => clearInterval(timer)
  }, [counter])

  useEffect(() => {
    if (!enableResendButton && counter !== 1) setCounter(30)
  }, [enableResendButton])

  return (
    <Box>
      <Typography variant="subtitle1" paragraph>
        Não recebeu seu código?&nbsp;
        {loading ? (
          <strong>Enviando...</strong>
        ) : enableResendButton ? (
          <Link
            style={{ cursor: 'pointer' }}
            onClick={resendEmail}
            aria-disabled={loading}
          >
            Reenviar
          </Link>
        ) : (
          <strong>Reenvie em {counter} segundos</strong>
        )}
      </Typography>
    </Box>
  )
}

export default memo(ResendEmail)
